module.exports = __webpack_public_path__ + "img/Cake_topper.43da9b8.jpg";